var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"handeCopy",attrs:{"data-clipboard-text":_vm.copyText},on:{"click":_vm.handeCopy}},[_vm._v("复制")])
}
var staticRenderFns = []

export { render, staticRenderFns }